<ng-container *ngIf="tenstarRating ; else translatable">
  <div class="paddingRow flex flex-row items-center  ">
    {{data}} <img [src]="rateThumb" class=" ml-2 ">
  </div>
</ng-container>

<ng-template #translatable>
  <div>
    {{this.utils.traslatei18n(data)}}
  </div>
</ng-template>



